import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const routes: Routes = [
   {
      path: 'demand-forecasts/vessel-lineup',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-list/vessel-lineup.component').then((c) => c.VesselLineupComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations',
      loadComponent: () =>
         import('./stock-simulations/stock-simulations.component').then((c) => c.StockSimulationsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/laycans',
      loadComponent: () =>
         import('./laycans/laycans.component').then((c) => c.LaycansComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_LAYCAN'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/laycans/:uuid',
      loadComponent: () =>
         import('./laycans/laycan-details/laycan-details.component').then((c) => c.LaycanDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/vessel-lineup/new',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-form/vessel-lineup-form.component').then((c) => c.VesselLineupFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_MANAGE_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/vessel-lineup/:vesselLineupUuid/edit',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-form/vessel-lineup-form.component').then((c) => c.VesselLineupFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_MANAGE_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations/:uuid',
      loadComponent: () =>
         import('./stock-simulations/stock-simulation-details/stock-simulation-details.component').then((c) => c.StockSimulationDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations/latest/:productUuid',
      loadComponent: () =>
         import('./stock-simulations/stock-simulation-details/stock-simulation-details.component').then((c) => c.StockSimulationDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
];